export const EnvItem = {
  Circle: {
    margin: 'X - -',
    round: 'radiusCard',
    boxSize: 'Z',
    isActive: (el) => el.isActive || el.parent.isActive,
    '.isActive': {
      background: 'green'
    },
    '!isActive': {
      background: 'shadow'
    }
  },
  Hgroup: {
    flow: 'y',
    margin: '- B - -',
    gap: 'X',
    H: {
      color: 'title',
      tag: 'span',
      overflow: 'hidden',
      whiteSpace: 'wrap',
      textOverflow: 'anywhere',
      text: '{{ publish.envs.production | polyglot }}'
    },
    P: {
      margin: '0',
      fontSize: 'Y2',
      fontWeight: '400',
      color: 'paragraph',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      whiteSpace: 'wrap',
      textOverflow: 'anywhere',
      lineBreak: 'anywhere',
      text: (el) => `${el.getAppKey()}`
    }
  },
  Buttons: {
    hide: (el) => el.getRootState('tier') === 'starter',
    margin: '-X -X - auto',
    EnvActive: {
      icon: 'checkmark',
      color: 'green'
    },
    childExtends: 'IconButton',
    childProps: {
      theme: 'transparent',
      padding: 'Y'
    }
  },
  Upgrade: {
    extends: 'Link',
    hide: (el) => el.getRootState('tier') !== 'starter',
    color: 'blue',
    text: '{{ publish.action.upgrade | polyglot }}',
    margin: '- - - auto',
    alignSelf: 'start',
    whiteSpace: 'nowrap',
    fontSize: 'Z2',
    lineHeight: 1,
    ':hover': {
      textDecoration: 'underline'
    },
    onClick: (f, el, st) => {
      el.call('openRouterModal', '/settings', {
        key: '/pricing'
      })
    }
  },
  flow: 'x',
  gap: 'Z',
  round: 'radiusControl',
  padding: 'Z Z2 Y'
}
